var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9407 14H6.05836C4.29366 14 3.11719 13.1176 3.11719 11.0588V6.94118C3.11719 4.88235 4.29366 4 6.05836 4H11.9407C13.7054 4 14.8819 4.88235 14.8819 6.94118V11.0588C14.8819 13.1176 13.7054 14 11.9407 14Z",
    stroke: "#292D32",
    strokeWidth: 0.784314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9409 7.23438L10.0998 8.70496C9.49388 9.18732 8.49977 9.18732 7.89388 8.70496L6.05859 7.23438",
    stroke: "#292D32",
    strokeWidth: 0.784314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.7dbe33d49540485b8599cc0d9cb8ac28.svg";
export { ForwardRef as ReactComponent };